import {getCookie, getTimeStamp, isLogin} from '@/utils/main';
import {
  LIVE_CONTEXT_MENU,
  MY_PLUS_LIVE_CONTEXT_MENU,
  SELECTED_MODE,
} from '@/constants/main';
import LiveBroadcastItem from '@/components/main/MyPlus/LiveBroadcastItem';
import {cookie} from '@afreecatv/domains';
import {SoopUiSwiper} from '@/components/ui';
import {BROADCAST_TYPES} from '@/constants';

const LiveDefaultTemplate = ({itemList, selectedMode, useSlider, log = {}}) => {
  const userId = getCookie(cookie.BBS_COOKIE_NAME);
  const uuid = getCookie('_au');
  const sessionId = uuid || userId;

  const renderItem = () => {
    return itemList.map((broadcast, idx) => (
      <li
        data-type='cBox'
        data-broadcast-id={broadcast.broadNo}
        key={broadcast.broadNo}>
        <LiveBroadcastItem
          broadcastType={BROADCAST_TYPES.LIVE}
          location='myplus'
          broadcastId={broadcast.broadNo}
          thumbnailUrl={broadcast.broadThumb}
          userId={broadcast.userId}
          userNickname={broadcast.userNick}
          viewCount={broadcast.totalViewCnt}
          liveType={broadcast.broadType}
          title={broadcast.broadTitle}
          categoryName={broadcast.categoryName}
          categoryNo={broadcast.broadCateNo}
          categoryTags={broadcast.categoryTags}
          autoHashTags={broadcast.autoHashtags}
          hashTags={broadcast.hashTags}
          canResend={Boolean(Number(broadcast.visitBroadType))}
          allowsAdult={Number(broadcast.broadGrade) === 19}
          listDataType={broadcast.listDataType}
          score={broadcast.score}
          startDateTime={broadcast.broadStart}
          hasDrops={Boolean(broadcast.isDrops)}
          hasPassword={broadcast.isPassword === 'Y'}
          contextMenu={{
            menuList:
              selectedMode === SELECTED_MODE.PREFER
                ? MY_PLUS_LIVE_CONTEXT_MENU
                : LIVE_CONTEXT_MENU,
          }}
          subscriptionOnly={broadcast.subscriptionOnly}
          log={{
            data: {
              path3: 'live',
              ...(selectedMode === SELECTED_MODE.PREFER && {
                listViewCliSession: `myplus_${sessionId}_${getTimeStamp()}`,
              }),
              ...(selectedMode === SELECTED_MODE.PREFER && {
                listViewSession: broadcast.listViewSession,
              }),
              ...log,
            },
            listDataType:
              selectedMode === SELECTED_MODE.PREFER
                ? broadcast.listDataType
                : undefined,
          }}
        />
      </li>
    ));
  };

  return (
    <>
      {useSlider && (
        <div className='cBox_slide'>
          <SoopUiSwiper
            swiperClass='cBox_list'
            options={{loop: itemList.length > 6}}
            maxSlidesPerView={6}
            otherMaxSlidesResolution={[
              {max: 1623, slidePerView: 6},
              {max: 1202, slidePerView: 5},
              {max: 1000, slidePerView: 4},
              {max: 751, slidePerView: 3},
              {max: 496, slidePerView: 2},
              {max: 0, slidePerView: 1},
            ]}
            swiperTag='ul'>
            {renderItem()}
          </SoopUiSwiper>
        </div>
      )}
      {!useSlider && (
        <div className='cBox-list'>
          <ul>{renderItem()}</ul>
        </div>
      )}
    </>
  );
};

export default LiveDefaultTemplate;
